// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendor" + "." + "e5ab56af7e0b58d2e7d7" + ".js";
};